<div
  class="ui right labeled left icon fluid action input"
  [ngClass]="{
    disabled: pageState === pageStateEnum.COUPON_CODE_APPLIED,
    action: pageState !== pageStateEnum.COUPON_CODE_APPLIED
  }"
>
  <i class="violet tags icon"></i>
  <input type="text" placeholder="Enter Code" #discountCodeInput />
  <button
    class="ui {{ buttonColor }}"
    (click)="applyDiscountCode(discountCodeInput.value)"
    [ngClass]="{
      'tag label disabled': pageState === pageStateEnum.COUPON_CODE_APPLIED,
      button: pageState !== pageStateEnum.COUPON_CODE_APPLIED
    }"
    [disabled]="discountValue"
  >
    <span *ngIf="pageState !== pageStateEnum.COUPON_CODE_APPLIED">Apply</span>
    <span *ngIf="pageState === pageStateEnum.COUPON_CODE_APPLIED"
      >{{ discountValue }}% applied</span
    >
  </button>
</div>

<div
  class="ui mini error message"
  *ngIf="pageState === pageStateEnum.COUPON_CODE_INVALID"
>
  <i class="close icon" (click)="hideInvalidMessage()"></i>
  Invalid Coupon Code
</div>
